<span class="badge" [ngClass]="leadStatusClass">
	{{ status | titlecase }}
</span>
